module.exports = __webpack_public_path__ + "static/media/compliance_tips_category_icon.06ecfdbf.svg";